<template>
  <SharedSidebarItem
    v-if="!disabled && !comingSoon"
    :name="name"
    :image="image"
    :iconComponent="iconComponent"
    :tag="tag"
    :targetRouteName="targetRouteName"
    :targetRouteAttributes="targetRouteAttributes"
    :isInertiaLink="isInertiaLink"
    :routeNamesToCheckIfCurrent="routeNamesToCheckIfCurrent"
    :itemOfPrimaryColumn="itemOfPrimaryColumn"
    :ghost="ghost"
    :badge="badge"
    :ordersRequiringActionCount="ordersRequiringActionCount"
    :totalPendingMediaRequestCount="totalPendingMediaRequestCount"
    @itemClicked="handleItemClick"
  />
  <ItemDisabled v-else :name="name" :iconComponent="iconComponent" placement="auto">
    <template v-if="comingSoon">
      <Box padding="small">
        <Stack space="small">
          <Typography color="body" variant="body" as="p"> This item is coming soon. </Typography>
        </Stack>
      </Box>
    </template>

    <template v-else>
      <Box padding="small">
        <Stack space="small">
          <Typography color="body" variant="body" as="p"
            >This feature is an Aryeo Pro <br />
            exclusive.</Typography
          >
          <Button text="Learn more" :link="route('web.company.billing.upgrade.show')" />
        </Stack>
      </Box>
    </template>
  </ItemDisabled>
</template>

<script setup>
import SharedSidebarItem from '@/Components/Shared/Navigation/Sidebar/SidebarItem.vue'
import ItemDisabled from '@/Components/Shared/Navigation/ItemDisabled.vue'

import { inject } from 'vue'

import { useSecondaryNavigation } from '@/Hooks/Company/Navigation/useSecondaryNavigation'
import { useOrdersRequiringAction } from '@/Hooks/Company/useOrdersRequiringAction'
import { useMediaRequests } from '@/Hooks/Company/useMediaRequests'
import { Box, Button, Stack, Typography } from '@aryeo/runway'

const props = defineProps({
  name: String,
  disabled: {
    type: Boolean,
    default: false,
  },
  comingSoon: {
    type: Boolean,
    default: false,
  },
  image: String,
  iconComponent: Function,
  tag: String,
  targetRouteName: String,
  targetRouteAttributes: Object,
  isInertiaLink: Boolean,
  routeNamesToCheckIfCurrent: Array,
  itemOfPrimaryColumn: Boolean,
  ghost: {
    type: Boolean,
    default: false,
  },
  badge: String,
})

const { count: ordersRequiringActionCount } = useOrdersRequiringAction()
const { totalPendingMediaRequestCount } = useMediaRequests()
const { secondaryNavigationForCurrentUrl } = useSecondaryNavigation()
const resetSecondaryColumnOpen = inject('resetSecondaryColumnOpen')

const handleItemClick = (e) => {
  if (
    props.itemOfPrimaryColumn &&
    props.targetRouteName === secondaryNavigationForCurrentUrl()?.overviewRouteName
  ) {
    resetSecondaryColumnOpen()
    e.preventDefault()
  }
}
</script>
